import { Box } from '@material-ui/core';
import { FbaFee, Order } from 'common/types'; // Adjust as per your actual types
import { TranslationPrefixes } from 'consts/translationPrefixes';
import { endOfDay, startOfDay } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getFees, getOrders } from 'services/service';
import CardComponent from '../shared/CardComponent';
import PeriodSelection from '../shared/PeriodSelection';
import AmazonExtract from './AmazonExtract';
import OrderChart from './OrderChart';

function WorkingDashboard() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [orders, setOrders] = useState<Order[]>([]);
    const [fees, setFees] = useState<FbaFee[]>([]);
    const [startDate, setStartDate] = useState<Date>(startOfDay(new Date())); // Default to start of today
    const [endDate, setEndDate] = useState<Date>(endOfDay(new Date())); // Default to end of today

    useEffect(() => {
        setIsLoading(true);
        Promise.all([getOrders(), getFees()])
            .then((val) => {
                setOrders(val[0]);
                setFees(val[1]);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    }, []);

    const { t } = useTranslation();
    const { sideBar } = TranslationPrefixes;

    const handleDatesChange = (startDate: Date, endDate: Date) => {
        setStartDate(startDate);
        setEndDate(endDate);
    };

    return (
        <>
            {/* <CardComponent title={t(`${sideBar}ordersVisualization`)} isLoading={isLoading} chartPrint>
                <Box>
                    <PeriodSelection onDatesChange={handleDatesChange} />
                    <OrderChart startDate={startDate} endDate={endDate} orders={orders} fees={fees} />
                </Box>
            </CardComponent> */}
            <Box mt={3}>
                <AmazonExtract />
            </Box>
        </>
    );
}

export default WorkingDashboard;
